export default __webpack_public_path__ + "static/media/pumpkin.21c70beb.png";